var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Slider from 'react-slick';
import { Styled } from './style';
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        return _super.call(this, props) || this;
    }
    Carousel.prototype.render = function () {
        return (React.createElement(Styled, null,
            React.createElement(Slider, { dots: this.props.dots, speed: this.props.speed, adaptiveHeight: this.props.adaptiveHeight, infinite: this.props.infinite, autoplay: this.props.autoplay, autoplaySpeed: this.props.autoplaySpeed, pauseOnHover: this.props.pauseOnHover, slidesToShow: this.props.slidesToShow, slidesToScroll: this.props.slidesToScroll }, this.props.children)));
    };
    Carousel.defaultProps = {
        dots: false,
        speed: 500,
        adaptiveHeight: true,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    return Carousel;
}(React.Component));
export default Carousel;
//# sourceMappingURL=index.js.map